const apiUrl = process.env.REACT_APP_API_URL;
export const GetJBbddProblemesIdEnviament = async (problemaId: string, id: string, id_practica?: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/problemes/${problemaId}/enviament`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id, idPractica: id_practica, idActivitat: id_practica })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
